
import {Vue, Component} from 'vue-property-decorator';
import {practitionerApi} from "@/api/practitioner";
import echarts from "echarts";
import {auditApi} from "@/api/audit";
//import SetTableColumns from "@/components/SetTableColumns.vue";

@Component({
  name: "Practitioner_Index"
  //components: {SetTableColumns}
})
export default class Index extends Vue {
  title1 = '从业人员年龄统计';
  title2 = '';
  tableList = [];
  showForm = false;
  myChart1 = null as any;
  myChart2 = null as any;
  fullScreen = false;

  mounted() {
    if(this.$route.path == "/statistics/practitionerIndexs/0"){
      this.fullScreen = true;
    }
    this.handleClick();
  }

  handleClick(){
    this.loadData();
  }

  loadEchart(xAxisData: any, seriesData: any, dataZoom: any) {

    if(this.myChart1){
      this.myChart1.dispose();
    }
    this.myChart1 = echarts.init(this.$refs.chart1);
    this.myChart1.setOption({
      title: {
        text: this.title1
      },
      tooltip: {},
      xAxis: {
        data: xAxisData
      },
      yAxis: {},
      dataZoom: dataZoom,
      series: [
        {
          name: '标准物质',
          type: 'bar',
          data: seriesData,
          itemStyle: {
            normal: {
              color: new echarts.graphic.LinearGradient(0, 1, 1, 0, [{
                offset: 0,
                color: "#1268f3" // 0% 处的颜色
              }, {
                offset: 0.6,
                color: "#08a4fa" // 60% 处的颜色
              }, {
                offset: 1,
                color: "#01ccfe" // 100% 处的颜色
              }], false)
            },
          },
          label: {
            show: true, //开启显示
            position: 'top', //在上方显示
            textStyle: { //数值样式
              color: 'red',
              fontSize: 16
            }
          }
        }
      ]
    });
    let _this = this;
    _this.myChart1.on('click',function(params:any){
      _this.title2=(params.name+'学历分布');
      _this.loadEchartPie(_this.getPieData(_this.tableList,params.name));
    });
  }

  loadEchartPie(tableData: any) {
    if(this.myChart2){
      this.myChart2.dispose();
    }
    this.myChart2 = echarts.init(this.$refs.chart2);
    this.myChart2.setOption({
      title: {
        text: this.title2
      },
      tooltip: {},
      color: ['#08a4fa', '#FF7A7A', '#33CC99', '#FF9393'],
      series: [
        {
          name: '学历构成',
          type: 'pie',
          radius: '85%',
          data: tableData,
          itemStyle: {
            shadowBlur: 200,
            shadowColor: 'rgba(0, 0, 0, 0)'
          },
          label: {
            normal: {
              formatter: '{a|{b}-{c}}',
              position: 'inner',
              rich: {
                a: {
                  color: '#000',
                  fontSize: 11,
                  lineHeight: 20,
                  align: 'center'
                }
              }
            },
          },
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)'
            }
          }
        }
      ]
    });
  }
  getPieData(list:any,name:any){
    let res = [];
    for(let item of list){
      if(item['age_type']==name){
        let czObj = {
          name: '初中'
          ,value: item['cz_num']
        };
        res.push(czObj);
        let gzObj = {
          name: '高中'
          ,value: item['gz_num']
        };
        res.push(gzObj);
        let zzObj = {
          name: '中专'
          ,value: item['zz_num']
        };
        res.push(zzObj);
        let zkObj = {
          name: '专科'
          ,value: item['zk_num']
        };
        res.push(zkObj);
        let bkObj = {
          name: '本科'
          ,value: item['bk_num']
        };
        res.push(bkObj);
        let ssObj = {
          name: '硕士'
          ,value: item['ss_num']
        };
        res.push(ssObj);
        let bsObj = {
          name: '博士'
          ,value: item['bs_num']
        };
        res.push(bsObj);
        let qtObj = {
          name: '其他'
          ,value: item['qt_num']
        };
        res.push(qtObj);
        let bxObj = {
          name: '不详'
          ,value: item['bx_num']
        };
        res.push(bxObj);
        break;
      }
    }
    return res;
  }
  //获取数据
  loadData() {
    practitionerApi.getPracttionerSum({}).then(res=>{
      if(res.data.result == 0){
        this.tableList=res.data.data;
        let xSeries:any = [];
        let ySeries:any = [];

        for(let item of this.tableList){
          xSeries.push(item['age_type']);
          ySeries.push(item['sum_num']);
        }
        this.loadEchart(xSeries, ySeries, []);

        this.title2=(this.tableList.length>0?(this.tableList[0]['age_type']+'学历分布'):'');
        this.loadEchartPie(this.getPieData(this.tableList,this.tableList.length>0?(this.tableList[0]['age_type']):''));
      }else{
        this.tableList=[];
      }
    });


    /*let resultList = JSON.parse(JSON.stringify(instrumentAll));
    const {证书编号, 等级, 标准物质名称, 标准物质研制机构} = this.propParams;
    if(证书编号 != ''){
      resultList = resultList.filter((r: any) => r.证书编号.indexOf(证书编号) > -1);
    }
    if(等级 != ''){
      resultList = resultList.filter((r: any) => r.等级 == 等级);
    }
    if(标准物质名称 != ''){
      resultList = resultList.filter((r: any) => r.标准物质名称.indexOf(标准物质名称) > -1);
    }
    if(标准物质研制机构 != ''){
      resultList = resultList.filter((r: any) => r.标准物质研制机构.indexOf(标准物质研制机构) > -1);
    }
    const newArr = resultList;

    const index = currPage; //从 1开始的页数
    const step = this.listParam.size;  //一页的数据量
    const d = newArr.length;
    const start = (index - 1) * step;  //
    const end = index * step > d ? d : index * step;
    this.tableList = newArr.slice(start, end);*/
  }
}
